import SubjectIcon from "@/app/components/logos/SubjectIcon";
import { capAll, getSubjectColorIndex } from "@/lib/strapi/formatters";
import { buildSubjectSlug } from "@/lib/utils/routing";
import { Box, Text } from "@mantine/core";
import Link from "next/link";
import classes from "./SubjectCard.module.css";

export default function SubjectCard({
  subjectName,
  href,
}: {
  subjectName: string;
  href?: string;
}) {
  const subjectColorIndex = getSubjectColorIndex(subjectName);
  return (
    <Box
      className={classes.subjectCard}
      component={Link}
      href={href ?? buildSubjectSlug(subjectName)}
    >
      <SubjectIcon
        subjectColorIndex={subjectColorIndex}
        className={classes.icon}
      />
      <Text
        className={classes.title}
        style={
          {
            "--sc-title-color": `var(--mantine-color-${subjectColorIndex}-5)`,
          } as React.CSSProperties
        }
      >
        {capAll(subjectName)}
      </Text>
    </Box>
  );
}
